import { DsPasswordChangeInterface } from '../interfaces/ds-password-change.interface';

export class DsPasswordChange {
  /**
   * The password changed
   */
  public passwordChanged: boolean;

  /**
   * Creates an instance of DsPasswordChange.
   *
   * @param jsonData the json data
   */
  constructor(jsonData: DsPasswordChangeInterface) {
    this.passwordChanged = jsonData.passwordChanged;
  }
}
